module.exports = __webpack_public_path__ + "static/media/rules_not_available_ic.a7e50461.svg";